import { Modal, Alert, Space } from 'antd';
import { useState, useEffect } from 'react';

const defaultController = { visible: false, text: <></>, footer: <></> };
export type ResultModal = { visible: boolean; text: JSX.Element; footer?: JSX.Element };

const useResultModal = () => {
  const [visible, setVisible] = useState<boolean>(false);
  const [controller, setController] = useState<ResultModal>(defaultController);

  useEffect(() => {
    if (controller.visible) {
      setVisible(true);
    } else {
      clear();
    }
  }, [controller.visible]);

  const clear = () => {
    setVisible(false);
    setController(defaultController);
  }

  return {
    E: <Modal
      visible={visible}
      footer={false}
      onCancel={clear}
    >
      <Space direction="vertical">
        {controller?.text}
        {controller?.footer}
      </Space>

    </Modal>,
    setController,
  }
}

export default useResultModal;